import React from 'react';
import { List, ListItem, ListItemText, CardContent, ListItemAvatar, Card } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { CardContentStyle, DocumentContainer } from './style';

export default function ListItemsContainer({ items = [] }) {
  return (
    <List>
      {items.map((item, index) => (
        <DocumentContainer key={item.id} href={item.fileLocation} download={item?.name} target="_blank">
          <ListItem key={index}>
            <Card variant="outlined" style={{ width: '100%' }}>
              <CardContent style={CardContentStyle}>
                <ListItemAvatar style={{ alignItems: 'center' }}>
                  <InsertDriveFileOutlinedIcon fontSize="large" color="MexlogGreen" />
                </ListItemAvatar>
                <ListItemText primary={item?.name || ''} />
              </CardContent>
            </Card>
          </ListItem>
        </DocumentContainer>
      ))}
    </List>
  );
}
